module.exports = __webpack_public_path__ + "static/media/dropdown-arrow-yellow.cd55ea33.svg";